module.exports = __webpack_public_path__ + "static/media/80-points.974cdfbb.png";